export const statusDisplayMap = {
  Pending: "Pending Registration",
  CertificateAvailable: "Certificate Ready",
  DownloadComplete: "Certificate Downloaded",
  PublishReady: "Device Ready",
  Failed: "Registration Failed",
  AdminApproval: "Awaiting Admin Approval",
  AdminApproved: "Approved by Admin",
  AdminRejected: "Rejected by Admin",
  Deregistered: "De-register the Device",
  Register: "Enable Registration",
};

export const statusOptions = [
  "Pending",
  "CertificateAvailable",
  "DownloadComplete",
  "PublishReady",
  "Failed",
  "AdminApproval",
  "AdminApproved",
  "AdminRejected",
  "Deregistered",
  "Register",
];

export const getAvailableStatusOptions = (currentStatus) => {
  switch (currentStatus) {
    case "DownloadComplete":
      return ["Deregistered"];
    case "PublishReady":
      return ["Deregistered"];
    case "Deregistered":
      return ["Register"];
    case "AdminApproval":
      return ["AdminApproved", "AdminRejected"];
    case "AdminRejected":
      return ["AdminApproval"];
    default:
      return statusOptions;
  }
};

export const isStatusFieldDisabled = (currentStatus) => {
  const disabledStatuses = [
    "Pending",
    "CertificateAvailable",
    "Failed",
    "AdminApproved",
    "Register",
  ];
  return disabledStatuses.includes(currentStatus);
};

export const transformDeviceData = (devices) => {
  if (!devices || devices.length === 0) return [];

  return devices.map((device, index) => ({
    sl_no: index + 1,
    DeviceId: device.deviceId,
    Status: device.status,
    StatusDisplay: statusDisplayMap[device.status] || device.status,
    Project:
      device.projectName && device.projectNumber
        ? `${device.projectName}(#${device.projectNumber})`
        : "--",
    weldType: device.weld_type || "--",
    welduid: device.weld_uid || "--",
    createdAt: device.createdAt,
    updatedAt: device.updatedAt,
    _original: device,
  }));
};
